__turbopack_context__.v({
  "qtySelector": "Lfo33a_qtySelector",
  "root": "Lfo33a_root",
  "sidebar-container": "Lfo33a_sidebar-container",
  "sidebar-container-inner": "Lfo33a_sidebar-container-inner",
  "sidebar-container-inner-wrapper": "Lfo33a_sidebar-container-inner-wrapper",
  "sidebar-main": "Lfo33a_sidebar-main",
  "sidebar-overlay": "Lfo33a_sidebar-overlay",
});
